'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./textarea.scss');

var _withFormField = require('../with-form-field');

var _withFormField2 = _interopRequireDefault(_withFormField);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Textarea(_ref) {
  var onRefsReady = _ref.onRefsReady,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ['onRefsReady', 'className']);

  var textareaClasses = (0, _classnames2.default)(className, 'textarea');

  return _react2.default.createElement('textarea', _extends({
    ref: function ref(textarea) {
      if (onRefsReady) {
        onRefsReady(textarea);
      }
    },
    className: textareaClasses
  }, props));
}

Textarea.propTypes = {
  className: _propTypes2.default.string,
  rows: _propTypes2.default.string,
  cols: _propTypes2.default.string,
  onRefsReady: _propTypes2.default.func
};

exports.default = (0, _withFormField2.default)(Textarea);